// extracted by mini-css-extract-plugin
export default {"hideScrollBar":"Staff_hideScrollBar__m6r0l"};